

















import { Component, Vue, Prop, Watch } from "vue-property-decorator";
@Component({
  name: "imageSetting",
})
export default class ImageSetting extends Vue {
  private imgUrl = "";
  @Prop({ type: Object, default: {} })
  item!: any;
  @Watch("item", { immediate: true, deep: true })
  dataChage(value: any) {
    this.imgUrl = value.url;
    console.log(this.imgUrl, "图片预览组件---", value);
  }
}
